import { http } from '../../../plugins/axios'

const actions = {
  get ({commit, dispatch}, payload) {
    let url = 'unit-types'
    let options = {
      emulateJSON: false
    }
    let params = {
      "perPage": payload.event.perPage,
      "page": payload.event.page,
      "sortKey": payload.event.sortKey ? payload.event.sortKey : 'alias',
      "ord": payload.event.ord,
      "find": payload.event.find !== '' ? payload.event.find : undefined
    }
    http.get(url, { params }, options)
      .then(response => {
        commit('onGet',  {event: payload.event, response})
      },
      error => {
        payload.event.context.showNotification(error.response, 'error')
      })
  },
  getAll ({commit, dispatch}, payload) {
    let url = `unit-types?page=1&perPage=-1`
    let options = {
      emulateJSON: false
    }
    http.get(url, {}, options)
      .then(response => {
        commit('onGetAll',  {event: payload.event, response})
      },
      error => {
        payload.event.context.showNotification(error.response, 'error')
      })
  },
  getById ({commit, dispatch}, payload) {
    let url = `unit-types/${payload.event.id}`
    let options = {
      emulateJSON: false
    }
    http.get(url, {}, options)
      .then(response => {
        commit('onGetById',  {event: payload.event, response})
      },
      error => {
        payload.event.context.showNotification(error.response, 'error')
      })
  },
  post ({commit, dispatch}, payload) {
    let url = 'unit-types'
    let options = {
      emulateJSON: false
    }
    http.post(url, payload.event.params, options)
      .then(response => {
        commit('onPost',  {event: payload.event, response})
      },
      error => {
        payload.event.context.showNotification(error.response, 'error')
      })
  },
  put ({commit, dispatch}, payload) {
    let url = `unit-types/${payload.event.id}`
    let options = {
      emulateJSON: false
    }
    http.put(url, payload.event.params, options)
      .then(response => {
        commit('onPut',  {event: payload.event, response})
      },
      error => {
        payload.event.context.showNotification(error.response, 'error')
      })
  },
  delete ({commit, dispatch}, payload) {
    let url = `unit-types/${payload.event.id}`
    let options = {
      emulateJSON: false
    }
    http.delete(url, {}, options)
      .then(response => {
        commit('onDelete',  {event: payload.event, response})
      },
      error => {
        payload.event.context.showNotification(error.response, 'error')
      })
  }
}

export default actions
